import styled, { css, keyframes } from 'styled-components';
import { spaceMixin, token } from '@zillow/constellation';

export type BoneTypes = 'bar' | 'line' | 'box' | 'badge';

const skeletonShimmer = keyframes`
    0% {
        opacity: 0.5;
    }
    100% {
        opacity: 1;
    }
`;

const typeMixin = (props: { type: BoneTypes }) => {
  switch (props.type) {
    case 'bar':
      return css`
        height: ${spaceMixin('xl')};
        width: 100%;
      `;
    case 'line':
      return css`
        height: ${spaceMixin('sm')};
        width: 100%;
      `;
    case 'box':
      return css`
        height: ${spaceMixin(25)};
        width: 300px;
      `;
    case 'badge':
      return css`
        height: ${spaceMixin('md')};
        width: 90px;
      `;
    default:
      return '';
  }
};

export const StyledBone = styled.div<{
  type: 'bar' | 'line' | 'box' | 'badge';
  cover: boolean;
  dark: boolean;
  light: boolean;
}>`
  ${typeMixin}
  ${(props) => css`
    animation: ${skeletonShimmer} 600ms linear infinite forwards alternate;

    ${props.light &&
    css`
      background-color: ${token('colors.white')};
    `}
    ${props.dark &&
    css`
      background-color: #ddd;
    `}
        ${props.cover &&
    css`
      height: 100%;
      width: 100%;
    `}
  `}
`;
